import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/images/caac_windDir.png'
import _imports_1 from '@/assets/images/vk_zl_line.png'
import _imports_2 from '@/assets/images/dangerIcon.png'
import _imports_3 from '@/assets/images/scene-setting.png'
import _imports_4 from '@/assets/images/subject.png'
import _imports_5 from '@/assets/images/error-icon.png'
import _imports_6 from '@/assets/images/star.png'
import _imports_7 from '@/assets/images/standard.png'
import _imports_8 from '@/assets/images/standard2.png'
import _imports_9 from '@assets/images/backIcon.png'
import _imports_10 from '@assets/images/star.png'
import _imports_11 from '@assets/images/standard.png'


const _hoisted_1 = { class: "flying-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "alarm-container" }
const _hoisted_4 = { class: "header-lf flex-row" }
const _hoisted_5 = { class: "header-rt flex-row" }
const _hoisted_6 = { class: "fps-container wind-dirct-container" }
const _hoisted_7 = { class: "fps-container" }
const _hoisted_8 = { class: "img-box" }
const _hoisted_9 = { class: "all-time" }
const _hoisted_10 = { class: "font-DIN" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "progress-box" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "subject-container" }
const _hoisted_15 = { class: "subject-modal-body" }
const _hoisted_16 = { class: "video-box" }
const _hoisted_17 = { class: "text-box" }
const _hoisted_18 = { class: "fly-deviation-info-container" }
const _hoisted_19 = { class: "deviation-header" }
const _hoisted_20 = {
  key: 1,
  class: "miniMap-container"
}
const _hoisted_21 = { class: "btn-group flex-row" }
const _hoisted_22 = {
  key: 1,
  class: "new-grad-container"
}
const _hoisted_23 = { class: "grad-inner" }
const _hoisted_24 = { class: "grad-body" }
const _hoisted_25 = { class: "grad-time-box" }
const _hoisted_26 = { class: "time-left-group" }
const _hoisted_27 = { class: "time-box-container" }
const _hoisted_28 = { class: "inner-box" }
const _hoisted_29 = { class: "time-text font-DIN" }
const _hoisted_30 = { class: "inner-box" }
const _hoisted_31 = { class: "time-text" }
const _hoisted_32 = { class: "warn-row" }
const _hoisted_33 = { class: "main-content-row" }
const _hoisted_34 = { class: "left-column" }
const _hoisted_35 = { class: "score-eval-row" }
const _hoisted_36 = { class: "info-btn score-card flex-row" }
const _hoisted_37 = { class: "vl-txt font-DIN" }
const _hoisted_38 = { class: "info-btn score-card flex-row" }
const _hoisted_39 = { class: "radar-box info-btn" }
const _hoisted_40 = { class: "deviation-row" }
const _hoisted_41 = { class: "right-column" }
const _hoisted_42 = { class: "info-btn eval-card flex-row" }
const _hoisted_43 = { class: "summary-card info-btn" }
const _hoisted_44 = { class: "summary-content" }
const _hoisted_45 = { class: "summary-text" }
const _hoisted_46 = { class: "summary-card info-btn" }
const _hoisted_47 = { class: "summary-content" }
const _hoisted_48 = { class: "suggest-text" }
const _hoisted_49 = { class: "grad-btn-container flex-row" }
const _hoisted_50 = { class: "btn-box" }
const _hoisted_51 = {
  key: 2,
  class: "grad-container"
}
const _hoisted_52 = { class: "grad-inner" }
const _hoisted_53 = { class: "grad-body" }
const _hoisted_54 = { class: "grad-time-box" }
const _hoisted_55 = { class: "time-box-container info-btn flex-row" }
const _hoisted_56 = { class: "inner-box" }
const _hoisted_57 = { class: "time-text font-DIN" }
const _hoisted_58 = { class: "warn-box" }
const _hoisted_59 = { class: "score-container" }
const _hoisted_60 = { class: "lf-box" }
const _hoisted_61 = { class: "lft-tp-box info-btn flex-row" }
const _hoisted_62 = { class: "vl-txt font-DIN" }
const _hoisted_63 = { class: "lft-bt-box info-btn flex-row" }
const _hoisted_64 = { class: "rgt-box info-btn" }
const _hoisted_65 = { class: "grad-base-info" }
const _hoisted_66 = { class: "grad-btn-container flex-row" }
const _hoisted_67 = { class: "btn-box" }
const _hoisted_68 = { class: "option-title-container" }
const _hoisted_69 = { class: "title-right" }
const _hoisted_70 = { class: "template-tooltip" }
const _hoisted_71 = { class: "perspective-tabs" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "perspective-setting-item" }
const _hoisted_74 = { class: "perspective-item-left" }
const _hoisted_75 = { class: "progress-container" }
const _hoisted_76 = { class: "perspective-item-right" }
const _hoisted_77 = { class: "perspective-setting-item" }
const _hoisted_78 = { class: "perspective-item-left" }
const _hoisted_79 = { class: "progress-container" }
const _hoisted_80 = { class: "perspective-item-right" }
const _hoisted_81 = { class: "perspective-setting-item" }
const _hoisted_82 = { class: "perspective-item-left" }
const _hoisted_83 = { class: "progress-container" }
const _hoisted_84 = { class: "perspective-item-right" }
const _hoisted_85 = { class: "perspective-setting-item" }
const _hoisted_86 = { class: "perspective-item-left" }
const _hoisted_87 = { class: "progress-container" }
const _hoisted_88 = { class: "perspective-item-right" }
const _hoisted_89 = { class: "distance-setting-item" }
const _hoisted_90 = { class: "distance-item-left" }
const _hoisted_91 = { class: "progress-container" }
const _hoisted_92 = { class: "perspective-item-right" }
const _hoisted_93 = { class: "light-show-setting-container" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "option-title-container light-show-setting-title" }
const _hoisted_96 = { class: "option-title-container light-show-setting-title" }

import {ref} from 'vue'
import useFlying from './index'
import {NProgress, NMarquee} from 'naive-ui'
import  useMouseHide from '@/hooks/useMouseHide'
import miniMap from '@/components/modules/miniMap/index.vue'
import flyBasicInfo from '@/components/modules/flight/flyInfo/flyBasicInfo.vue'
import flyDeviationInfo from '@/components/modules/flight/flyInfo/flyDeviationInfo.vue'




export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 定义组件的属性
},
  emits: {
  // 定义组件的事件
},
  setup(__props, { emit: __emit }) {

const timeBoxRef = ref<HTMLDivElement | null>(null);
const timeBox = ref<HTMLDivElement | null>(null);
const progressRef = ref<HTMLDivElement | null>(null);
const flyCanvasRef = ref<HTMLDivElement | null>(null);
const gradCanvasRef = ref<HTMLDivElement | null>(null);
const promptRef = ref<HTMLDivElement | null>(null);
const promptTextRef = ref<HTMLDivElement | null>(null);
const flyDeviationInfoRef = ref<any>(null);
const gradeFlyDeviationInfoRef = ref<any>(null);
const { isMouseHidden } = useMouseHide(3000)



const props = __props

const emits = __emit

const {
    sceneImage,
    progressValue,
    receive,
    sum,
    speed,
    currentFile,
    maxFile,
    uavStatusList,
    connectIcon,
    currentTime,
    isShowAlarm,
    currentPage,
    gradInfo,
    gradScore,
    evaluate,
    handleRestart,
    currentStepIndex,
    altitude,
    horizonalSpeed,
    courseAngle,
    realTimeAngleOffset,
    angularSpeed,
    flyingInfo,
    guidStatus,
    totalSeconds,
    showAiInstructor,
    showPrompt,
    promptText,
    showOpenAiPrompt,
    isMarqueeActive,
    fpsStatus,
    connectStatus,
    isReady,
    collisionAlarm,
    crash,
    currentWindSpeed,
    alarmType,
    sightHeight,
    sightDist,
    sightFov,
    changeFovDist,
    lightDirection,
    showAuxiliaryViewport,
    shadowEnable,
    lightDirectionList,
    confirmLoading,
    resetLoading,
    subjectList,
    showSubjectModal,
    subjectTitle,
    submitVideoUrl,
    openSubjectModal,
    perspectiveTabList,
    perspectiveTab,
    isCustomPerspective,
    centerBucketDist,
    showTemplateTooltip,
    flyDeviationViewMode,
    permissionLevel,
    trainingId,
    userWaserInfo,

    $config,
    containerWidth,
    $enum,
    AlarmType,
    lockStatus,
    lockIcon,
    handleBack,
    handleBackCallback,
    handleSwitch,
    currentSeconds,
    handleLock,
    onGround,
    engineInitialized,
    gradTotalTime,
    pageVisible,
    loading3D,
    loadingProgess,
    characterMode,
    closeAiInstructor,
    switchAiInstructor,
    handleOpenPDF,
    handleSwitchSetting,
    handleSwitchPerspectiveTab,
    handleReset,
    handleConfirm,
    handleRefreshUserConfig,
    stop,
    speak,
    isAlwaysVisibleAi,
    aiCoachSettlementData,
    handleOpenSettingFullscreen,
    openFlyReplay,
    currentWindDirection
} = useFlying(props, emits, timeBoxRef, timeBox, progressRef, flyCanvasRef, gradCanvasRef, promptRef, promptTextRef, flyDeviationInfoRef, gradeFlyDeviationInfoRef);


return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vkm_remoteStatus = _resolveComponent("vkm-remoteStatus")!
  const _component_vkm_aiInstructor = _resolveComponent("vkm-aiInstructor")!
  const _component_vkm_videoPlayer = _resolveComponent("vkm-videoPlayer")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_vkm_sceneSetting = _resolveComponent("vkm-sceneSetting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentPage) == 1)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: _unref(sceneImage),
          receive: _unref(receive),
          sum: _unref(sum),
          speed: _unref(speed),
          currentFile: _unref(currentFile),
          maxFile: _unref(maxFile),
          progressValue: _unref(loadingProgess),
          title: _unref(loading3D).title,
          description: _unref(loading3D).description,
          pageType: _unref(loading3D).pageType
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _unref(isShowAlarm) || _unref(collisionAlarm)]
      ]),
      _createElementVNode("div", {
        class: "caac-header flex-row",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important', zIndex: _unref(currentPage) == 4 ? -1 : 5 })
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "iconfont-line vk_prevleft_line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleBackCallback)('icon'))),
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uavStatusList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(index <= _unref(currentStepIndex)?'uav-status-item active-status':'uav-status-item'),
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item), 1),
              (index != _unref(uavStatusList)?.length - 1)
                ? (_openBlock(), _createBlock(_component_vkm_svg, {
                    key: 0,
                    "icon-name": index < _unref(currentStepIndex)?'current_step':'uncurrent_step' ,
                    class: "icon"
                  }, null, 8, ["icon-name"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "img-box" }, [
              _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_0,
                alt: ""
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(currentWindSpeed)) + "m/s", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[30] || (_cache[30] = _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_1,
                alt: ""
              }, null, -1)),
              _withDirectives(_createElementVNode("img", {
                class: "denger-icon",
                src: _imports_2,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleOpenPDF) && _unref(handleOpenPDF)(...args))),
                alt: ""
              }, null, 512), [
                [_vShow, _unref(fpsStatus) < 30]
              ])
            ]),
            _createElementVNode("p", null, [
              _cache[31] || (_cache[31] = _createTextVNode("FPS:")),
              _createElementVNode("span", {
                class: _normalizeClass({'danger':_unref(fpsStatus) < 30})
              }, _toDisplayString(_unref(fpsStatus)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "all_time",
              class: "icon"
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(gradTotalTime)), 1)
          ]),
          _createElementVNode("img", {
            class: "connect-icon",
            src: _unref(connectIcon),
            alt: "",
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 12, _hoisted_11),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "设置",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont-fill vk_sz_fill header-icon",
                style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : !_unref(isReady) ? 'not-allowed !important' : 'pointer !important' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(handleOpenSettingFullscreen)(_unref(isReady))))
              }, null, 4)
            ]),
            _: 1
          })
        ])
      ], 4),
      _createElementVNode("div", {
        class: "countdown-container",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important', zIndex: _unref(currentPage) == 4 ? -1 : 5 })
      }, [
        _createElementVNode("div", {
          ref_key: "timeBoxRef",
          ref: timeBoxRef,
          class: "progress-content"
        }, [
          (_unref(totalSeconds) != -1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-time time-container':'time-container'),
                ref_key: "timeBox",
                ref: timeBox
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(currentTime)), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dv3" }, null, -1)),
            (_unref(totalSeconds) != -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-dv4 dv4':'dv4'),
                  ref_key: "progressRef",
                  ref: progressRef
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ], 4),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(lockStatus) == _unref($enum).SWITCH_STATUS.ON && !_unref(onGround)?'none-click-btn lock-container':'lock-container' ),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleLock) && _unref(handleLock)(...args))),
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important', zIndex: _unref(currentPage) == 4 ? -1 : 5 })
      }, [
        _createElementVNode("img", {
          src: _unref(lockIcon),
          alt: ""
        }, null, 8, _hoisted_13)
      ], 6),
      _createVNode(_component_vkm_remoteStatus, {
        isRemoteConnected: !!_unref(connectStatus),
        isReady: _unref(isReady),
        style: _normalizeStyle({ zIndex: _unref(currentPage) == 4 ? -1 : 10 })
      }, null, 8, ["isRemoteConnected", "isReady", "style"]),
      _createVNode(_component_vkm_aiInstructor, {
        style: _normalizeStyle({zIndex: _unref(currentPage) == 4 ? -1 : 5 }),
        alarmType: _unref(alarmType),
        isMouseHidden: _unref(isMouseHidden),
        promptText: _unref(promptText),
        speak: _unref(speak),
        stop: _unref(stop),
        isAlwaysVisible: true
      }, null, 8, ["style", "alarmType", "isMouseHidden", "promptText", "speak", "stop"]),
      _createElementVNode("img", {
        src: _imports_3,
        class: _normalizeClass(['scene-setting-icon', !_unref(isReady)?'disabled-subject':'']),
        alt: "",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleSwitchSetting)('open')))
      }, null, 2),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          class: _normalizeClass(!_unref(isReady)?'disabled-subject':''),
          src: _imports_4,
          alt: "",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(openSubjectModal) && _unref(openSubjectModal)(...args)))
        }, null, 2)
      ]),
      (_unref(showSubjectModal))
        ? (_openBlock(), _createBlock(_component_vkm_modal, {
            key: 0,
            class: "subject-modal-container",
            title: _unref(subjectTitle),
            onOnClose: _cache[6] || (_cache[6] = ()=>{showSubjectModal.value = false;}),
            isFooter: false
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_vkm_videoPlayer, {
                    videoSrc: _unref(submitVideoUrl),
                    showCloseIcon: false
                  }, null, 8, ["videoSrc"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[33] || (_cache[33] = _createElementVNode("p", null, "科目要求", -1)),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(flyBasicInfo, {
        altitude: _unref(altitude),
        horizonalSpeed: _unref(horizonalSpeed),
        courseAngle: _unref(courseAngle),
        realTimeAngleOffset: _unref(realTimeAngleOffset),
        angularSpeed: _unref(angularSpeed),
        isMouseHidden: _unref(isMouseHidden)
      }, null, 8, ["altitude", "horizonalSpeed", "courseAngle", "realTimeAngleOffset", "angularSpeed", "isMouseHidden"]), [
        [_vShow, _unref(currentPage) == 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "header-title" }, "飞行数据", -1)),
          (_unref(permissionLevel) == 1)
            ? (_openBlock(), _createBlock(_component_vkn_button, {
                key: 0,
                class: "insert-btn",
                label: _unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? '曲线' : '卡片' ,
                type: "tertiary",
                size: "medium",
                onClick: _cache[7] || (_cache[7] = ()=>{flyDeviationViewMode.value = _unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? _unref($enum).FlyDeviationViewMode.曲线 : _unref($enum).FlyDeviationViewMode.卡片;})
              }, {
                icon: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createElementVNode("i", { class: "iconfont-line vk_qh_line" }, null, -1)
                ])),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createVNode(flyDeviationInfo, {
          ref_key: "flyDeviationInfoRef",
          ref: flyDeviationInfoRef,
          isMouseHidden: _unref(isMouseHidden),
          isReady: _unref(isReady),
          flyingInfo: _unref(flyingInfo),
          viewMode: _unref(flyDeviationViewMode)
        }, null, 8, ["isMouseHidden", "isReady", "flyingInfo", "viewMode"]), [
          [_vShow, _unref(currentPage) == 2]
        ])
      ], 512), [
        [_vShow, _unref(isReady) && _unref(currentPage) == 2]
      ]),
      (_unref(showAuxiliaryViewport) && _unref(currentPage) == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(miniMap)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "uav-actions-container",
        style: _normalizeStyle({ zIndex: _unref(currentPage) == 4 ? -1 : 5 })
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_vkn_button, {
            label: _unref(guidStatus) == 1?'关闭引导':'开启引导',
            type: "tertiary",
            size: "medium",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(handleSwitch)('guid'))),
            isSetMouseHidden: true,
            isHiddenMouse: _unref(isMouseHidden)
          }, {
            icon: _withCtx(() => _cache[36] || (_cache[36] = [
              _createElementVNode("i", { class: "iconfont-line vk_jz_line1" }, null, -1)
            ])),
            _: 1
          }, 8, ["label", "isHiddenMouse"]),
          _createVNode(_component_vkn_button, {
            class: "insert-btn",
            label: "视角",
            type: "tertiary",
            size: "medium",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(handleSwitch)('view'))),
            isSetMouseHidden: true,
            isHiddenMouse: _unref(isMouseHidden)
          }, {
            icon: _withCtx(() => _cache[37] || (_cache[37] = [
              _createElementVNode("i", { class: "iconfont-line vk_qh_line" }, null, -1)
            ])),
            _: 1
          }, 8, ["isHiddenMouse"]),
          _createVNode(_component_vkn_button, {
            label: "重置",
            type: "tertiary",
            size: "medium",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(handleSwitch)('reset'))),
            isSetMouseHidden: true,
            isHiddenMouse: _unref(isMouseHidden)
          }, {
            icon: _withCtx(() => _cache[38] || (_cache[38] = [
              _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
            ])),
            _: 1
          }, 8, ["isHiddenMouse"])
        ]),
        _createElementVNode("div", {
          class: "canvas-container electronic-pile-container info-btn",
          ref_key: "flyCanvasRef",
          ref: flyCanvasRef,
          style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
        }, null, 4)
      ], 4)
    ], 512), [
      [_vShow, _unref(currentPage) == 2 || _unref(currentPage) == 4]
    ]),
    (_unref(currentPage) == 3 && _unref(permissionLevel) == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("span", null, "成绩")
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_el_scrollbar, {
                class: "grad-scrollbar",
                "wrap-class": "grad-scrollbar-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "clock",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(gradTotalTime)), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "time-box-container",
                        onClick: _cache[11] || (_cache[11] = ()=>{flyDeviationViewMode.value = _unref(flyDeviationViewMode) === 'card' ? 'line' : 'card';})
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "vk_qh_line",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(flyDeviationViewMode) === 'card' ? '曲线' : '卡片'), 1)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_32, _cache[39] || (_cache[39] = [
                      _createElementVNode("div", { class: "warn-box" }, [
                        _createElementVNode("img", {
                          src: _imports_5,
                          alt: ""
                        }),
                        _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分")
                      ], -1)
                    ]), 512), [
                      [_vShow, _unref(crash)]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper star-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_6,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "得分")
                          ], -1)),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(gradScore)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper check-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_7,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "成绩")
                          ], -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(_unref(evaluate)?'green':'red')
                          }, _toDisplayString(_unref(evaluate)?'合格':'不合格'), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", {
                          class: "electronic-pile-container",
                          ref_key: "gradCanvasRef",
                          ref: gradCanvasRef
                        }, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(flyDeviationInfo, {
                          ref_key: "gradeFlyDeviationInfoRef",
                          ref: gradeFlyDeviationInfoRef,
                          isReady: true,
                          flyingInfo: _unref(flyingInfo),
                          viewMode: _unref(flyDeviationViewMode)
                        }, null, 8, ["flyingInfo", "viewMode"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _cache[42] || (_cache[42] = _createElementVNode("div", { class: "img-box flex-row" }, [
                          _createElementVNode("div", { class: "icon-wrapper thumb-icon" }, [
                            _createElementVNode("img", {
                              src: _imports_8,
                              alt: ""
                            })
                          ]),
                          _createElementVNode("span", null, "AI飞行评价")
                        ], -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['eval-text', _unref(aiCoachSettlementData)?.rating === '优秀' ? 'green' : _unref(aiCoachSettlementData)?.rating === '良好' ? 'yellow' : 'red'])
                        }, _toDisplayString(_unref(aiCoachSettlementData)?.rating || '暂无评价'), 3)
                      ]),
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "ability-radar-box info-btn" }, [
                        _createElementVNode("div", { id: "echartBox" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_43, [
                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "飞行总结")
                        ], -1)),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: _unref(aiCoachSettlementData)?.flightConclusion || '暂无总结' ,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(aiCoachSettlementData)?.flightConclusion || '暂无总结'), 1)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "AI教员训练建议")
                        ], -1)),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: _unref(aiCoachSettlementData)?.trainingSuggestion || '暂无建议' ,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(aiCoachSettlementData)?.trainingSuggestion || '暂无建议'), 1)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_vkn_button, {
                  label: "飞行回放",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(openFlyReplay)
                }, {
                  icon: _withCtx(() => _cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "iconfont-line vk_hf_line" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_vkn_button, {
                  label: "重新开始",
                  type: "tertiary",
                  size: "medium",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(handleRestart)(false)))
                }, {
                  icon: _withCtx(() => _cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_vkn_button, {
                  label: "返回",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(handleBackCallback)
                }, {
                  icon: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createElementVNode("img", { src: _imports_9 }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentPage) == 3 && _unref(permissionLevel) == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("span", null, "成绩")
            ], -1)),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_vkm_svg, {
                      "icon-name": "clock",
                      class: "icon"
                    }),
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(gradTotalTime)), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_58, _cache[50] || (_cache[50] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    alt: ""
                  }, null, -1),
                  _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分", -1)
                ]), 512), [
                  [_vShow, _unref(crash)]
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_10 }),
                      _createElementVNode("span", null, "得分")
                    ], -1)),
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(gradScore)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_11 }),
                      _createElementVNode("span", null, "评价")
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(_unref(evaluate)?'vl-txt green':'vl-txt red')
                    }, _toDisplayString(_unref(evaluate)?'合格':'不合格'), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", {
                    class: "inner-box electronic-pile-container",
                    ref_key: "gradCanvasRef",
                    ref: gradCanvasRef
                  }, null, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(flyDeviationInfo, {
                  ref_key: "gradeFlyDeviationInfoRef",
                  ref: gradeFlyDeviationInfoRef,
                  isReady: true,
                  flyingInfo: _unref(flyingInfo),
                  viewMode: 'card'
                }, null, 8, ["flyingInfo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_component_vkn_button, {
                  label: "重新开始",
                  type: "tertiary",
                  size: "medium",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(handleRestart)(false)))
                }, {
                  icon: _withCtx(() => _cache[53] || (_cache[53] = [
                    _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_vkn_button, {
                  label: "返回",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(handleBackCallback)
                }, {
                  icon: _withCtx(() => _cache[54] || (_cache[54] = [
                    _createElementVNode("img", { src: _imports_9 }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentPage) == 4)
      ? (_openBlock(), _createBlock(_component_vkm_sceneSetting, {
          key: 3,
          title: "场景设置",
          resetLoading: _unref(resetLoading),
          confirmLoading: _unref(confirmLoading),
          onOnClose: _cache[28] || (_cache[28] = ($event: any) => (_unref(handleSwitchSetting)('close'))),
          onOnReset: _unref(handleReset),
          onOnConfirm: _unref(handleConfirm)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_68, [
              _cache[59] || (_cache[59] = _createElementVNode("span", null, "视角设置", -1)),
              _createElementVNode("div", _hoisted_69, [
                _cache[58] || (_cache[58] = _createElementVNode("span", null, "三维视角位置设置", -1)),
                _createElementVNode("div", {
                  class: "tooltip-wrapper",
                  onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (showTemplateTooltip.value = true)),
                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (showTemplateTooltip.value = false))
                }, [
                  _cache[57] || (_cache[57] = _createElementVNode("i", { class: "iconfont-line vk_ts_line" }, null, -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_70, _cache[56] || (_cache[56] = [
                    _createElementVNode("div", { class: "tooltip-title" }, "模版说明", -1),
                    _createElementVNode("div", { class: "tooltip-content" }, [
                      _createElementVNode("div", { class: "tooltip-item" }, [
                        _createElementVNode("div", { class: "tooltip-item-title" }, "1.新标准"),
                        _createElementVNode("div", { class: "tooltip-item-desc" }, "按2025年12月30日发布的《民用中小型无人驾驶航空器操控员培训训练机构规范》要求，操作区域到中心桶距离为15m进行设定。建议以此标准执飞。")
                      ]),
                      _createElementVNode("div", { class: "tooltip-item" }, [
                        _createElementVNode("div", { class: "tooltip-item-title" }, "2.旧标准"),
                        _createElementVNode("div", { class: "tooltip-item-desc" }, "按2024年5月11日发布的《民用无人驾驶航空器操控员执照考试管理方法》要求，操作区域到中心桶距离为12m进行设定，可作为辅助练习模版。")
                      ]),
                      _createElementVNode("div", { class: "tooltip-item" }, [
                        _createElementVNode("div", { class: "tooltip-item-title" }, "3.通用"),
                        _createElementVNode("div", { class: "tooltip-item-desc" }, "从新手上手角度考虑，操作区域到中心桶距离为10m进行设定，可做新手短时上手的练习模版。")
                      ]),
                      _createElementVNode("div", { class: "tooltip-item" }, [
                        _createElementVNode("div", { class: "tooltip-item-title" }, "4.自定义"),
                        _createElementVNode("div", { class: "tooltip-item-desc" }, "结合个人习惯自定义设置视角高度、视角距离等参数，生成个性化视角模版。")
                      ])
                    ], -1)
                  ]), 512), [
                    [_vShow, _unref(showTemplateTooltip)]
                  ])
                ], 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(perspectiveTabList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(['tab-item', { 'active': _unref(perspectiveTab) === index }]),
                  key: index,
                  onClick: ($event: any) => (_unref(handleSwitchPerspectiveTab)(index))
                }, _toDisplayString(item), 11, _hoisted_72))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "title-text" }, "视高", -1)),
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: _unref(sightHeight),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(sightHeight) ? (sightHeight).value = $event : null)),
                    min: 1.0,
                    max: 5.0,
                    step: 0.1,
                    "show-tooltip": false,
                    disabled: !_unref(isCustomPerspective),
                    onChange: _unref(handleRefreshUserConfig)
                  }, null, 8, ["modelValue", "disabled", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createVNode(_component_el_input_number, {
                  class: "custom-numner-input",
                  precision: 1,
                  modelValue: _unref(sightHeight),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(sightHeight) ? (sightHeight).value = $event : null)),
                  min: 1.0,
                  max: 5.0,
                  step: 0.1,
                  controls: false,
                  disabled: !_unref(isCustomPerspective),
                  onChange: _unref(handleRefreshUserConfig)
                }, {
                  suffix: _withCtx(() => _cache[61] || (_cache[61] = [
                    _createElementVNode("span", null, "m", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _cache[62] || (_cache[62] = _createElementVNode("span", { class: "title-text" }, "视距", -1)),
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: _unref(sightDist),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(sightDist) ? (sightDist).value = $event : null)),
                    min: 9.0,
                    max: 20.0,
                    step: 1,
                    "show-tooltip": false,
                    disabled: !_unref(isCustomPerspective),
                    onChange: _unref(handleRefreshUserConfig)
                  }, null, 8, ["modelValue", "disabled", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_el_input_number, {
                  class: "custom-numner-input",
                  precision: 1,
                  modelValue: _unref(sightDist),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(sightDist) ? (sightDist).value = $event : null)),
                  min: 9.0,
                  max: 20.0,
                  controls: false,
                  disabled: !_unref(isCustomPerspective),
                  onChange: _unref(handleRefreshUserConfig)
                }, {
                  suffix: _withCtx(() => _cache[63] || (_cache[63] = [
                    _createElementVNode("span", null, "m", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _cache[64] || (_cache[64] = _createElementVNode("span", { class: "title-text" }, "视宽", -1)),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: _unref(sightFov),
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(sightFov) ? (sightFov).value = $event : null)),
                    min: 40,
                    max: 120,
                    step: 1,
                    "show-tooltip": false,
                    disabled: !_unref(isCustomPerspective),
                    onChange: _unref(handleRefreshUserConfig)
                  }, null, 8, ["modelValue", "disabled", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_el_input_number, {
                  class: "custom-numner-input",
                  precision: 0,
                  modelValue: _unref(sightFov),
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(sightFov) ? (sightFov).value = $event : null)),
                  min: 40,
                  max: 120,
                  controls: false,
                  disabled: !_unref(isCustomPerspective),
                  onChange: _unref(handleRefreshUserConfig)
                }, {
                  suffix: _withCtx(() => _cache[65] || (_cache[65] = [
                    _createElementVNode("span", null, "°", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _cache[66] || (_cache[66] = _createElementVNode("span", { class: "title-text" }, "感距", -1)),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: _unref(changeFovDist),
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(changeFovDist) ? (changeFovDist).value = $event : null)),
                    min: 12,
                    max: 100,
                    step: 1,
                    "show-tooltip": false,
                    disabled: !_unref(isCustomPerspective),
                    onChange: _unref(handleRefreshUserConfig)
                  }, null, 8, ["modelValue", "disabled", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createVNode(_component_el_input_number, {
                  class: "custom-numner-input",
                  precision: 0,
                  modelValue: _unref(changeFovDist),
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(changeFovDist) ? (changeFovDist).value = $event : null)),
                  min: 12,
                  max: 100,
                  controls: false,
                  disabled: !_unref(isCustomPerspective),
                  onChange: _unref(handleRefreshUserConfig)
                }, {
                  suffix: _withCtx(() => _cache[67] || (_cache[67] = [
                    _createElementVNode("span", null, "m", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled", "onChange"])
              ])
            ]),
            _cache[72] || (_cache[72] = _createElementVNode("div", { class: "option-title-container light-show-setting-title" }, [
              _createElementVNode("span", null, "无人机到中心桶距离")
            ], -1)),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _cache[68] || (_cache[68] = _createElementVNode("span", { class: "title-text" }, "距离", -1)),
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: _unref(centerBucketDist),
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(centerBucketDist) ? (centerBucketDist).value = $event : null)),
                    min: 6,
                    max: 10,
                    step: 0.1,
                    "show-tooltip": false,
                    onChange: _unref(handleRefreshUserConfig)
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _createVNode(_component_el_input_number, {
                  class: "custom-numner-input",
                  precision: 1,
                  modelValue: _unref(centerBucketDist),
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(centerBucketDist) ? (centerBucketDist).value = $event : null)),
                  min: 6,
                  max: 10,
                  controls: false,
                  onChange: _unref(handleRefreshUserConfig)
                }, {
                  suffix: _withCtx(() => _cache[69] || (_cache[69] = [
                    _createElementVNode("span", null, "m", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]),
            _cache[73] || (_cache[73] = _createElementVNode("div", { class: "option-title-container light-show-setting-title" }, [
              _createElementVNode("span", null, "光照设置"),
              _createElementVNode("span", null, "阴影方向设置")
            ], -1)),
            _createElementVNode("div", _hoisted_93, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lightDirectionList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(['light-show-setting-item', {'active-light-show': _unref(lightDirection) == index}]),
                  key: index,
                  onClick: ()=>{lightDirection.value = index; _unref(handleRefreshUserConfig)()}
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.time), 1),
                  _createElementVNode("span", null, "(" + _toDisplayString(item.angle) + "°)", 1)
                ], 10, _hoisted_94))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_95, [
              _cache[70] || (_cache[70] = _createElementVNode("span", null, "辅助视口", -1)),
              _createVNode(_component_el_switch, {
                class: "custom-switch",
                modelValue: _unref(showAuxiliaryViewport),
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(showAuxiliaryViewport) ? (showAuxiliaryViewport).value = $event : null)),
                onChange: _unref(handleRefreshUserConfig)
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _cache[71] || (_cache[71] = _createElementVNode("span", null, "阴影显示", -1)),
              _createVNode(_component_el_switch, {
                class: "custom-switch",
                modelValue: _unref(shadowEnable),
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(shadowEnable) ? (shadowEnable).value = $event : null)),
                onChange: _unref(handleRefreshUserConfig)
              }, null, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }, 8, ["resetLoading", "confirmLoading", "onOnReset", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ]))
}
}

})